import { render, staticRenderFns } from "./PublisherInvitations.vue?vue&type=template&id=e1dbcd9c&scoped=true&lang=pug"
import script from "./PublisherInvitations.vue?vue&type=script&lang=js"
export * from "./PublisherInvitations.vue?vue&type=script&lang=js"
import style0 from "./PublisherInvitations.vue?vue&type=style&index=0&id=e1dbcd9c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1dbcd9c",
  null
  
)

export default component.exports